var _rect, _rect2, _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#D1EFE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#6D708D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.668 25.3327V13.666M19.668 25.3327H14.668C12.3113 25.3327 11.1321 25.3327 10.4005 24.6002C9.66797 23.8685 9.66797 22.6893 9.66797 20.3327V13.666C9.66797 11.3093 9.66797 10.1302 10.4005 9.39852C11.1321 8.66602 12.3113 8.66602 14.668 8.66602C17.0246 8.66602 18.2038 8.66602 18.9355 9.39852C19.668 10.1302 19.668 11.3093 19.668 13.666M19.668 25.3327H23.0013C24.573 25.3327 25.358 25.3327 25.8463 24.8443C26.3346 24.356 26.3346 23.571 26.3346 21.9993V16.9993C26.3346 15.4277 26.3346 14.6427 25.8463 14.1543C25.358 13.666 24.573 13.666 23.0013 13.666H19.668M13.418 16.166H12.5846M16.7513 16.166H15.918M13.418 12.8327H12.5846M13.418 19.4993H12.5846M16.7513 12.8327H15.918M16.7513 19.4993H15.918M23.418 19.4993H22.5846M23.418 16.166H22.5846",
    stroke: "#36384A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 6,
    r: 3.75,
    fill: "#00D193",
    stroke: "#66887E",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.caa525bc9e6e2227cb10222890242679.svg";
export { ForwardRef as ReactComponent };